// eslint-disable-next-line
export default (state: any, action: any) => {
  switch (action.type) {
    case "SELECTED_POLICY":
      return {
        ...state,
        selectedPolicy: action.payload,
      };
    case "PREVIEW_POLICY":
      return {
        ...state,
        previewPolicy: action.payload,
      };
    default:
      return state;
  }
};
